const views = {
  'aem-view@': {
      template: '<wow-aem-portal project="generic"></wow-aem-portal>'
  }
};

module.exports = function ($stateProvider) {
  const analyticsData = {
      isAEM: true,
      pageMetadata: [
          'PageMetadataService', function () {
              return null;
          }
      ],
      fullPageRefreshOnForceReload: true
  };
  $stateProvider
      .state('shop.discover', {
          url: '/discover',
          data: analyticsData,
          views
      })
      .state('shop.discover.page', {
          url: '{path:any}', // avoid '/' being encoded
          data: analyticsData,
          views
      })
      ;
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/configuration/routes/discover.js
 **/